import React from "react";
import { EnrichedProgram } from "@/common/course/types";
import { ClientSideNewProductCard } from "@/components/NewProductCard";
import { constructUrl } from "@/utils/functions/constructUrl";

interface ProgramCardProps {
  item: EnrichedProgram;
  index: number;
  getUrl: (path?: string) => string | undefined;
  skipViewEvent?: boolean;
  skipClickEvent?: boolean;
}

// Component for individual program card with eventing
function ProgramCard({
  item,
  index,
  getUrl,
  skipViewEvent = false,
  skipClickEvent = false,
}: ProgramCardProps) {
  const imageUrl = item.cardImageUrl || "";
  const partnerName = item.partners?.[0]?.name || "";
  const partnerLogoUrl = item.partners?.[0]?.logoUrl || "";
  const courseCount = item.courses?.length || 0;

  return (
    <div className="inline">
      <ClientSideNewProductCard
        href={constructUrl(item?.marketingUrl, getUrl)}
        imageUrl={imageUrl}
        name={item.title}
        partnerLogoUrl={partnerLogoUrl}
        partnerKey={[partnerName]}
        type="Course"
        uuid={item.uuid}
        weeksToComplete={item.weeksToComplete}
        pacing={"self_paced"}
        childCoursesCount={courseCount}
        location="program-carousel"
        index={index}
        productCardType={{
          singleCourseTags: [
            { tags: "CompletionTime" },
            { tags: "Pacing" },
            { tags: "CourseCount" },
          ],
        }}
        subjects={item?.subjects ?? []}
        cta={{
          topCtaText: item.type,
          backgroundColor: "putty-200",
        }}
        skipViewEvent={skipViewEvent}
        skipClickEvent={skipClickEvent}
      />
    </div>
  );
}

export default ProgramCard;
